export class Modifierarticle {
  constructor(
    id,
    description,
    max_n,
    name,
    price,
    priority,
    manual_active,
    plu,
    active,
    translation_id,
    print_name,
    handheld_only,
    meta_json,
    modifiergroupIds,
    updated_at,
    pos_name,
    print_name_2,
    is_side_dish
  ) {
    this.id = id;
    this.description = description;
    this.max_n = max_n;
    this.name = name;
    this.price = price;
    this.priority = priority;
    this.manual_active = manual_active;
    this.plu = plu;
    this.active = active;
    this.translation_id = translation_id;
    this.print_name = print_name;
    this.handheld_only = handheld_only;
    this.meta_json = meta_json;
    this.modifiergroupIds = modifiergroupIds;
    this.updated_at = updated_at;
    this.pos_name = pos_name;
    this.print_name_2 = print_name_2;
    this.is_side_dish = is_side_dish;
  }

  get key() {
    return this.id + "-" + this.updated_at;
  }
}

export const CreateModifierarticle = (json, modifiergroupIds) => {
  return new Modifierarticle(
    json.id,
    json.description,
    json.max_n,
    json.modifierarticle.name,
    json.price,
    json.priority,
    json.manual_active,
    json.plu,
    json.active,
    json.translation_id,
    json.print_name,
    json.handheld_only,
    json.meta_json,
    modifiergroupIds,
    json.updated_at,
    json.pos_name,
    json.print_name_2,
    json.is_side_dish
  );
};
